import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import userType from '../types/user.type';
import base64 from 'base-64';

export const getAllUser = (currentPage: number, pagerSize: number,showAllUsers:boolean) => {
	return (dispatch: Dispatch) => {
		dispatch(getAllUserStart());
		let url = URLConstants.GetAllUser + '?pageNo=' + currentPage + '&pageSize=' + pagerSize + '&showAll=' + showAllUsers;
		services.get(url)
			.then(response => {
				dispatch(getAllUserSuccess(response.data));
			})
			.catch(err => {
				dispatch(getAllUserError(err));
			});
	};
};

const getAllUserStart = () => {
	return {
		type: userType.GET_ALL_USER_START
	};
};

const getAllUserSuccess = (data: any) => {
	return {
		type: userType.GET_ALL_USER_SUCCESS,
		payload: data
	};
};

const getAllUserError = (data: any) => {
	return {
		type: userType.GET_ALL_USER_ERROR,
		payload: data
	};
};

const deleteUserStart = () => {
	return {
		type: userType.DELETE_USER_START
	};
};

const deleteUserSuccess = (data: any) => {
	return {
		type: userType.DELETE_USER_SUCCESS,
		payload: data
	};
};

const deleteUserError = (data: any) => {
	return {
		type: userType.DELETE_USER_ERROR,
		payload: data
	};
};

const resetDeleteUserDispatcher = () => {
	return {
		type: userType.RESET_DELETE_USER_STATE
	};
};

export const resetDeleteUserState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetDeleteUserDispatcher());
	};
};


export const deleteUser = (id: number) => {
	return (dispatch: Dispatch) => {
		dispatch(deleteUserStart());
		let url = URLConstants.DeleteUser + '/' + id;
		services.deleteapi(url)
			.then(response => {
				if (response.data)
					dispatch(deleteUserSuccess(response.data));
				else
					dispatch(deleteUserError('Message_Some_Error_Occured'));
			})
			.catch(err => {
				dispatch(deleteUserError(err));
			});
	};
};



const addUserStart = () => {
	return {
		type: userType.ADD_USER_START
	};
};

const addUserSuccess = (data: any) => {
	return {
		type: userType.ADD_USER_SUCCESS,
		payload: data
	};
};

const addUserError = (data: any) => {
	return {
		type: userType.ADD_USER_ERROR,
		payload: data
	};
};

const resetAddUserDispatcher = () => {
	return {
		type: userType.RESET_ADD_USER_STATE
	};
};

export const resetAddUserState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetAddUserDispatcher());
	};
};

export const addUser = (id: number, data: any) => {
	return (dispatch: Dispatch) => {
		const defaultPassword = "_AQS_Daikin123";
		dispatch(addUserStart());
		let userData: any;
		let url = URLConstants.UpdateUser;
		if (id === -1) {
			url = URLConstants.AddUser;
			userData = {
				userType: data.UserType ? 0 : 1,
				userName: data.UserName,
				email: data.UserName.trim(),
				password: base64.encode(data.Password),
				confirmPassword: base64.encode(data.ConfirmPassword),
				status: 0,
				timezoneId: 49
			}
		}
		else {
			userData = {
				Id: id,
				userType: data.UserType ? 0 : 1,
				userName: data.UserName,
				email: data.UserName.trim(),
				status: 0,
				timezoneId: 49
			};
		}

		if (data.IsDefaultPassword) {
			userData.password = base64.encode(defaultPassword);
			userData.confirmPassword = base64.encode(defaultPassword);
		}


		services.post(url, userData)
			.then(response => {
				dispatch(addUserSuccess(response.data));
			})
			.catch(err => {
				dispatch(addUserError(err));
			});
	};
};

const getUserByIdStart = () => {
	return {
		type: userType.GET_USER_BY_ID_START
	};
};

const getUserByIdSuccess = (data: any) => {
	return {
		type: userType.GET_USER_BY_ID_SUCCESS,
		payload: data
	};
};

const getUserByIdError = (data: any) => {
	return {
		type: userType.GET_USER_BY_ID_ERROR,
		payload: data
	};
};

const resetGetUserByIdDispatcher = () => {
	return {
		type: userType.RESET_GET_USER_BY_ID_STATE
	};
};

export const resetGetUserByIdState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetUserByIdDispatcher());
	};
};

export const getUserById = (id: number) => {
	return (dispatch: Dispatch) => {
		dispatch(getUserByIdStart());
		let url = URLConstants.GetUserById + '/' + id;
		services.get(url)
			.then(response => {
				dispatch(getUserByIdSuccess(response.data));
			})
			.catch(err => {
				dispatch(getUserByIdError(err));
			});
	};
};

//userdevices

export const userDevices = (userId:number) => {
	return (dispatch: Dispatch) => {
		dispatch(getuserDevicesStart());
		let url = URLConstants.GetUserDevicesById + `?userId=${userId} `
		services.get(url)
			.then(response => {
				dispatch(userDevicesSuccess(response.data));
			})
			.catch(err => {
				dispatch(userDevicesError(err));
			});
	};
};

const resetUserDevicesStateDispatcher = () => {
	return {
		type: userType.RESET_USER_DEVICES_STATE
	};
};

export const resetUserDevicesState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetUserDevicesStateDispatcher());
	};
};

const getuserDevicesStart = () => {
	return {
		type: userType.GET_USER_DEVICES_START
	};
};

const userDevicesSuccess = (data: any) => {
	return {
		type: userType.GET_USER_DEVICES_SUCCESS,
		payload: data
	};
};

const userDevicesError = (data: any) => {
	return {
		type: userType.GET_USER_DEVICES_ERROR,
		payload: data
	};
};
